// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AgreementView .Ccm-PageHeader.view-header-tabs {
  padding-left: 0;
}
.AgreementView .AgreementContentWrapper {
  text-align: center;
}
.AgreementView .AgreementContentWrapper .AgreementContent {
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  max-width: 800px;
  text-align: left;
}
.AgreementView .AgreementVersionsList {
  margin-top: 20px;
}
.AgreementView img[ccm-text-item-media-model] {
  cursor: pointer;
}

@media print {
  .AgreementView .Ccm-PageHeader {
    display: none;
  }
  .AgreementView .AgreementContentWrapper .AgreementContent {
    max-width: 100%;
    margin-top: 0;
  }
  .AgreementVersionsList {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./Source/app/agreement/agreement-view/agreement-view.component.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;AADZ;AAKI;EACI,kBAAA;AAHR;AAKQ;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAHZ;AAOI;EACI,gBAAA;AALR;AAOI;EACI,eAAA;AALR;;AASA;EAEQ;IACI,aAAA;EAPV;EAWU;IACI,eAAA;IACA,aAAA;EATd;EAcE;IACI,aAAA;EAZN;AACF","sourcesContent":[".AgreementView {\r\n    .Ccm-PageHeader {\r\n        &.view-header-tabs {\r\n            padding-left: 0;\r\n        }\r\n    }\r\n\r\n    .AgreementContentWrapper {\r\n        text-align: center;\r\n\r\n        .AgreementContent {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n            margin-top: 25px;\r\n            max-width: 800px;\r\n            text-align: left;\r\n        }\r\n    }\r\n\r\n    .AgreementVersionsList {\r\n        margin-top: 20px;\r\n    }\r\n    img[ccm-text-item-media-model] {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n@media print {\r\n    .AgreementView {\r\n        .Ccm-PageHeader {\r\n            display: none;\r\n        }\r\n\r\n        .AgreementContentWrapper {\r\n            .AgreementContent {\r\n                max-width: 100%;\r\n                margin-top: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .AgreementVersionsList {\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
